export default "__VITE_ASSET__ec08807e__"